import { Actions } from '@/config/store.config';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import store from '@/store';
import { v4 as uuidv4 } from 'uuid';
import appconfigService from '@/services/appconfig/appconfig.service';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/select-language',
    name: 'selectLanguage',
    component: () => import('../views/SelectLanguageView.vue'),
  },
  {
    path: '/select-type',
    name: 'selectType',
    component: () => import('../views/SelectTypeView.vue'),
    meta: { languageSelector: true },
  },
  {
    path: '/groups',
    name: 'groups',
    component: () => import('../views/GroupsView.vue'),
    meta: { languageSelector: true },
  },
  {
    path: '/group/:id/:categoryId?',
    name: 'group',
    component: () => import('../views/SingleGroupView.vue'),
    meta: { languageSelector: true },
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/CategoriesView.vue'),
    meta: { languageSelector: true },
  },
  {
    path: '/category/:id',
    name: 'category',
    component: () => import('../views/SingleCategoryView.vue'),
    meta: { languageSelector: true },
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/checkout/OrderView.vue'),
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: () => import('../views/checkout/ConfirmView.vue'),
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('../views/checkout/InfoView.vue'),
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/checkout/PaymentView.vue'),
  },
  {
    path: '/refund',
    name: 'refund',
    component: () => import('../views/checkout/RefundView.vue'),
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('../views/checkout/SuccessView.vue'),
  },
  {
    path: '/refund-success',
    name: 'refund-success',
    component: () => import('../views/checkout/RefundSuccessView.vue'),
  },
  {
    path: '/thanks-you',
    name: 'thanks-you',
    component: () => import('../views/checkout/ThanksYouView.vue'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/checkout/ErrorView.vue'),
  },
  {
    path: '/refund-error',
    name: 'refund-error',
    component: () => import('../views/checkout/RefundErrorView.vue'),
  },
  {
    path: '/cash-payment',
    name: 'cash-payment',
    component: () => import('../views/checkout/CashPaymentVue.vue'),
  },
  {
    path: '/your-phone',
    name: 'phone-number',
    component: () => import('../views/PhoneNumberView.vue'),
    meta: { languageSelector: true },
  },
  {
    path: '/your-name',
    name: 'client-name',
    component: () => import('../views/ClientNameView.vue'),
    meta: { languageSelector: true },
  },
  {
    path: '/unavailable',
    name: 'unavailable',
    component: () => import('../views/checkout/UnavailableView.vue'),
  },
  {
    path: '/turn',
    name: 'turn',
    component: () => import('../views/TurnNumberView.vue'),
  },
  {
    path: '/test/printer-test-page',
    name: 'test',
    component: () => import('../views/tests/PrinterTestView.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.name === 'home') {
    try {
      const appConfig = await appconfigService.get();
      await store.dispatch(Actions.CONFIGURE_LANGUAGE, {
        appConfig,
        reset: true,
      });
    } catch {
      await store.dispatch(Actions.SET_LANGUAGE, 'es');
    }
  }

  try {
    if (store.getters.isAuthenticated) {
      await store.dispatch(Actions.VERIFY_AUTH);
    } else {
      const uuid = uuidv4();
      await store.dispatch(Actions.SIGNUP_GUEST, uuid);
    }
  } catch {
    // Individual service calls will surface authentication failures.
  }

  next();
});

export default router;
